import { render, staticRenderFns } from "./TaskPointOverTime.vue?vue&type=template&id=2a7a7560&scoped=true"
import script from "./TaskPointOverTime.vue?vue&type=script&lang=js"
export * from "./TaskPointOverTime.vue?vue&type=script&lang=js"
import style0 from "./TaskPointOverTime.vue?vue&type=style&index=0&id=2a7a7560&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a7560",
  null
  
)

export default component.exports